import React, { useState, ChangeEvent, FormEvent } from "react";
import { Link } from "react-router-dom";

type FormState = {
  date: string;
  timeFrom: string;
  timeTo: string;
  start: string;
  target: string;
  floor: string;
  truck: "Ja" | "Nein";
  what: string;
  name: string;
  phone: string;
  email: string;
  privacy: boolean;
};

export default function ContactForm() {
const [sent, setSent] = useState<boolean>(false);
const [form, setForm] = useState<FormState>({
  date: "",
  timeFrom: "",
  timeTo: "",
  start: "",
  target: "",
  floor: "",
  truck: "Ja",
  what: "",
  name: "",
  phone: "",
  email: "",
  privacy: false,
});


  // ✅ SAUBERER onChange – minimal & korrekt
const onChangeValue = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
) => {
  const { name, value } = e.target;
  setForm((p) => ({ ...p, [name]: value }));
};

const onChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, checked } = e.target;
  setForm((p) => ({ ...p, [name]: checked }));
};

  const EMAIL_TO = "mohammadalshabani@icloud.com";
  const WHATSAPP_NUMBER = "4917641011065";

  const buildMessage = (f: FormState) =>
    `Umzugsanfrage:\n` +
    `Wunschtermin: ${f.date} von ${f.timeFrom} bis ${f.timeTo}\n` +
    `Start: ${f.start}\n` +
    `Ziel: ${f.target}\n` +
    `Etage/Fahrstuhl: ${f.floor}\n` +
    `Mit Transporter: ${f.truck}\n` +
    `Was: ${f.what}\n` +
    `Name: ${f.name}\n` +
    `Telefon: ${f.phone}\n` +
    `E-Mail: ${f.email}`;

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!form.privacy) {
      alert("Bitte Datenschutzerklärung akzeptieren.");
      return;
    }

    setSent(true);

    const subject = encodeURIComponent(`Umzugsanfrage ${form.name}`);
    const body = encodeURIComponent(buildMessage(form));

    window.location.href = `mailto:${EMAIL_TO}?subject=${subject}&body=${body}`;
  };

  const buildWhatsAppUrl = (f: FormState) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      buildMessage(f)
    )}`;

  return (
    <section id="kontakt" className="py-10 md:py-16">
      <div className="max-w-[1100px] mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold">
          Umzugsanfrage – in 2 Minuten
        </h2>

        <form
          onSubmit={onSubmit}
          className="mt-5 grid md:grid-cols-2 gap-4 rounded-2xl p-5 md:p-6 shadow"
        >
          {/* Datum */}
          <div>
            <label className="text-sm font-medium">Wunschtermin</label>
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={onChangeValue}
              required
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          {/* Zeit */}
<div>
  <label className="text-sm font-medium">Uhrzeit von</label>
  <input
    type="time"
    name="timeFrom"
    value={form.timeFrom}
    onChange={onChangeValue}
    required
    className="mt-1 w-full rounded-xl border p-3 min-h-[48px]"
  />
</div>

<div>
  <label className="text-sm font-medium">Uhrzeit bis</label>
  <input
    type="time"
    name="timeTo"
    value={form.timeTo}
    onChange={onChangeValue}
    required
    min={form.timeFrom || undefined}
    className="mt-1 w-full rounded-xl border p-3 min-h-[48px]"
  />
</div>



          {/* Adressen */}
          <div>
            <label className="text-sm font-medium">Startadresse</label>
            <input
              type="text"
              name="start"
              value={form.start}
              onChange={onChangeValue}
              required
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Zieladresse</label>
            <input
              type="text"
              name="target"
              value={form.target}
              onChange={onChangeValue}
              required
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          {/* Zusatz */}
          <div>
            <label className="text-sm font-medium">Etage / Fahrstuhl</label>
            <input
              type="text"
              name="floor"
              value={form.floor}
              onChange={onChangeValue}
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Mit Transporter?</label>
            <select
              name="truck"
              value={form.truck}
              onChange={onChangeValue}
              className="mt-1 w-full rounded-xl border p-3"
            >
              <option value="Ja">Ja</option>
              <option value="Nein">Nein</option>
            </select>
          </div>

          {/* Beschreibung */}
          <div className="md:col-span-2">
            <label className="text-sm font-medium">
              Was soll transportiert werden?
            </label>
            <textarea
              name="what"
              value={form.what}
              onChange={onChangeValue}
              rows={4}
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          {/* Kontakt */}
          <div>
            <label className="text-sm font-medium">Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={onChangeValue}
              required
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          <div>
            <label className="text-sm font-medium">Telefon</label>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={onChangeValue}
              required
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          <div className="md:col-span-2">
            <label className="text-sm font-medium">E-Mail</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={onChangeValue}
              required
              className="mt-1 w-full rounded-xl border p-3"
            />
          </div>

          {/* Datenschutz */}
          <div className="md:col-span-2 flex items-center gap-3 text-sm">
            <input
              id="privacy"
              name="privacy"
              type="checkbox"
              checked={form.privacy}
              onChange={onChangeCheckbox}
              required
            />
            <label htmlFor="privacy">
              Ich habe die{" "}
              <Link to="/datenschutz" className="underline" target="_blank">
                Datenschutzerklärung
              </Link>{" "}
              gelesen und akzeptiere sie.
            </label>
          </div>

          {/* Buttons */}
          <div className="md:col-span-2 grid sm:grid-cols-2 gap-3">
<button
  type="submit"
  disabled={!form.privacy}
  className={`rounded-xl px-5 py-4 font-semibold text-white
    ${form.privacy ? "bg-[#FF6B00]" : "bg-gray-300 cursor-not-allowed"}
  `}
>
  Absenden
</button>

<a
  href={form.privacy ? buildWhatsAppUrl(form) : undefined}
  onClick={(e) => {
    if (!form.privacy) e.preventDefault();
  }}
  className={`rounded-xl px-5 py-4 font-semibold border text-center
    ${form.privacy ? "border-slate-300" : "border-gray-300 text-gray-400 cursor-not-allowed"}
  `}
>
  Per WhatsApp anfragen
</a>

          </div>

          {sent && (
            <div className="md:col-span-2 text-sm text-slate-600">
              Danke! Ihre Anfrage wird jetzt im E-Mail-Programm geöffnet.
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
